import { DataTable } from '@datahub/design-system'
import { scanStateText } from '../scan-state'

export interface AttachmentView {
  id: string
  fileName: string
  sizeBytes: number
  documentType: string | null
  virusScanStatus: string
  uploadedAt: string
}

/**
 * The files of a submission. The scan state shows once for each file: a blocked file has
 * its state in place of the download link, and a clean file has the link. A separate
 * column for the state would say the same thing twice.
 */
export function AttachmentsTable({ attachments, onDownload }: { attachments: AttachmentView[]; onDownload: (a: AttachmentView) => void }) {
  return (
    <DataTable
      caption="Attachments"
      columns={[
        { key: 'file', header: 'File', width: 320, sticky: true, render: (a: AttachmentView) => a.fileName },
        { key: 'type', header: 'Type', width: 200, render: (a: AttachmentView) => a.documentType ?? '-' },
        {
          key: 'download', header: 'Download', width: 300,
          render: (a: AttachmentView) => {
            const blocked = scanStateText(a.virusScanStatus)
            if (blocked) return <span className="text-text-support" style={{ fontSize: 12 }}>{blocked}</span>
            return (
              <button
                type="button"
                onClick={() => onDownload(a)}
                className="text-text-hyperlink hover:underline"
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 12, padding: 0 }}
              >
                Download
              </button>
            )
          },
        },
      ]}
      rows={attachments}
      rowKey={(a) => a.id}
      emptyMessage="No files attached"
    />
  )
}
